import { useContext } from 'react'
import { SubscriptionVerificationContext } from './context'

export function useSubscriptionVerification() {
  const context = useContext(SubscriptionVerificationContext)

  if (context === undefined) {
    throw new Error(
      'useSubscriptionVerificationContext must be used within a SubscriptionVerificationProvider'
    )
  }

  return context
}
